/* Pinbuds reviews (Review Manager). Server-rendered cards come from Liquid; this file adds the
   lightbox, row arrows, homepage chips, and more cards / filters from the public feed:
     https://pinbuds-reviews.pinbuds-team.workers.dev/v1/pinbuds/...
   A 410 reloads the shop manifest; a 503 shows "Reviews are updating". Product feeds are only
   ever addressed with the publication id that the product's own pointer printed into the page.
   Nothing is fetched until a reviews block is near the viewport or a control is used.
   Products: Liquid decides which linked products are live (snippets/pbrm-live-check) and prints
   them as data-l on each card and as [data-pbr-lv] lists. Handles it could not look up are settled
   through sections/pbrm-live (Section Rendering API, all_products in Liquid). A review with no live
   product joins its generic group (Pin / Bag / Accessory reviews); its product stays plain text. */
(function () {
  if (window.PBR) return;
  var FEED = 'https://pinbuds-reviews.pinbuds-team.workers.dev/v1/pinbuds';
  var CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var CHEV_L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 6-6 6 6 6"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmtD(d) { if (!d) return ''; var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d); return m ? (+m[3]) + ' ' + MON[+m[2] - 1] + ' ' + m[1].slice(2) : ''; }
  function cfgOf(root) { try { return JSON.parse(root.querySelector('script[data-pbr-cfg]').textContent); } catch (e) { return null; } }
  function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(fn, { timeout: 1500 }); }

  /* ---------- feed ---------- */
  function FeedError(status) { this.status = status; }
  function getJSON(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new FeedError(r.status);
      return r.json();
    });
  }
  function shopPage(cfg, n, q) {
    var url = FEED + '/shop/' + encodeURIComponent(cfg.pub) + '/pages/' + n + (q || '');
    return getJSON(url).catch(function (e) {
      if (e && e.status === 410) {
        return getJSON(FEED + '/manifest').then(function (m) {
          if (!m || m.version !== 1 || !m.complete) throw new FeedError(503);
          cfg.pub = m.publication_id; cfg.pages = m.page_count; cfg.reset = true;
          return getJSON(FEED + '/shop/' + encodeURIComponent(cfg.pub) + '/pages/' + n + (q || ''));
        });
      }
      throw e;
    });
  }
  // A product publication replaced since this page rendered answers 410; its new id is only known
  // from a fresh render, so report it as updating rather than guess.
  function productPage(p, n) { return getJSON(FEED + '/products/' + encodeURIComponent(p.id) + '/' + encodeURIComponent(p.pub) + '/pages/' + n).catch(function (e) { if (e && e.status === 410) { p.pages = 0; throw new FeedError(503); } throw e; }); }

  /* ---------- live products (mirrors snippets/pbrm-live-check.liquid) ---------- */
  var LV = {};
  function seedLV() {
    [].forEach.call(document.querySelectorAll('script[data-pbr-lv]'), function (el) {
      try { var d = JSON.parse(el.textContent); String(d.live || '').split('|').forEach(function (h) { if (h) LV[h] = 1; }); String(d.dead || '').split('|').forEach(function (h) { if (h && LV[h] !== 1) LV[h] = 0; }); } catch (e) {}
    });
  }
  function pid(p) { return String((p && p.gid) || '').replace('gid://shopify/Product/', ''); }
  function stateOf(p, bags) {
    if (p && p.available === true) return '1';
    if (p && p.available === false) return '0';
    var h = String((p && p.handle) || '');
    if (!h) return '0';
    if (bags && bags.indexOf('|' + pid(p) + '|') > -1) return '1';
    if (LV[h] === 1) return '1';
    if (LV[h] === 0) return '0';
    return '?';
  }
  function grpOf(r, states) {
    if (states.indexOf('1') > -1 || states.indexOf('?') > -1) return '';
    if (r && Object.prototype.hasOwnProperty.call(r, 'category')) return { bag: 'Bag reviews', pin: 'Pin reviews', accessory: 'Accessory reviews' }[r.category] || 'Reviews';
    // older payloads without category: product titles, then Pin reviews
    var t = ' ' + (r.products || []).map(function (p) { return p.title || ''; }).join(' ').toLowerCase().replace(/[",()]/g, ' ') + ' ';
    if (/ bags? |backpack| tote | sling /.test(t)) return 'Bag reviews';
    if (/keychain|charm|lanyard|strap/.test(t)) return 'Accessory reviews';
    return 'Pin reviews';
  }
  function grpRow(g) { return g === 'Bag reviews' ? 'b' : 'a'; }
  function imgOf(p) { var v = p && (p.image_url || p.image || p.featured_image); return typeof v === 'string' ? v : ''; }
  // Ask Liquid (sections/pbrm-live) about handles we have no answer for; 18 per call.
  var lvPending = {};
  function ensureLive(handles) {
    var want = [];
    handles.forEach(function (h) { h = String(h || ''); if (h && /^[a-z0-9][a-z0-9-]*$/i.test(h) && LV[h] === undefined && want.indexOf(h) < 0) want.push(h); });
    var jobs = [];
    for (var i = 0; i < want.length; i += 18) {
      (function (chunk) {
        var key = chunk.join(' ');
        if (!lvPending[key]) lvPending[key] = fetch('/search?q=' + encodeURIComponent(key) + '&section_id=pbrm-live', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (t) {
            var m = /<script[^>]*data-pbr-live[^>]*>([\s\S]*?)<\/script>/.exec(t); if (!m) return;
            var d = JSON.parse(m[1]); (d.live || []).forEach(function (h) { LV[h] = 1; }); (d.dead || []).forEach(function (h) { if (LV[h] !== 1) LV[h] = 0; });
          }).catch(function () {}).then(function () { delete lvPending[key]; });
        jobs.push(lvPending[key]);
      })(want.slice(i, i + 18));
    }
    return Promise.all(jobs);
  }
  function ensureLiveFor(reviews, bags) {
    var hs = [];
    (reviews || []).forEach(function (r) { (r.products || []).forEach(function (p) { if (stateOf(p, bags) === '?') hs.push(p.handle); }); });
    return ensureLive(hs);
  }
  // Settle server-rendered cards whose products Liquid could not look up.
  function settleCards(scope) {
    var cards = [].slice.call(scope.querySelectorAll('.pbr-card')).filter(function (c) { return c.querySelector('[data-prods] i[data-l="?"], [data-prods] i[data-l=""]'); });
    if (!cards.length) return Promise.resolve();
    var hs = [];
    cards.forEach(function (c) { [].forEach.call(c.querySelectorAll('[data-prods] i'), function (i) { var l = i.getAttribute('data-l'); if (l === '?' || l === '') hs.push(i.getAttribute('data-h')); }); });
    return ensureLive(hs).then(function () {
      cards.forEach(function (c) {
        var states = '', fake = { products: [] }, dc = c.getAttribute('data-cat');
        if (dc != null) fake.category = dc === 'null' ? null : dc;
        [].forEach.call(c.querySelectorAll('[data-prods] i'), function (i) {
          var l = i.getAttribute('data-l');
          if (l === '?' || l === '') { var h = i.getAttribute('data-h'); l = !h ? '0' : LV[h] === 1 ? '1' : LV[h] === 0 ? '0' : '?'; i.setAttribute('data-l', l); }
          states += l; fake.products.push({ title: i.getAttribute('data-t') });
        });
        var g = grpOf(fake, states);
        if (g && !c.hasAttribute('data-grp')) markGrp(c, g);
        if (states.charAt(0) === '0') unPill(c.querySelector('.pbr-prod'));
      });
    });
  }
  function unPill(ch) { if (ch) ['data-pbqv-pill', 'data-url', 'role', 'tabindex', 'aria-label'].forEach(function (a) { ch.removeAttribute(a); }); }
  function markGrp(c, g) {
    c.setAttribute('data-grp', g); c.classList.add('pbr-card--grp');
    var top = c.querySelector('.pbr-card__top');
    if (top && !top.querySelector('.pbr-grp')) top.insertAdjacentHTML('beforeend', '<span class="pbr-grp">' + esc(g) + '</span>');
    var chip = c.querySelector('.pbr-prod'); if (chip) { chip.classList.add('pbr-prod--off'); unPill(chip); }
  }

  /* ---------- card (mirrors snippets/pbrm-card.liquid) ---------- */
  function kindOf(r, bags) {
    var k = 's';
    (r.products || []).some(function (p) { var id = String(p.gid || '').replace('gid://shopify/Product/', ''); if (bags.indexOf('|' + id + '|') > -1) { k = 'b'; return true; } k = 'a'; return false; });
    return k;
  }
  function card(r, bags) {
    var rated = r.rating !== null && r.rating !== undefined && r.rating !== '';
    var who = r.anonymous ? 'Anonymous' : ((String(r.author || '').trim() || 'Customer').split(/\s+/)[0]); // first name only
    var m0 = (r.media || [])[0], img = m0 ? (m0.kind === 'video' ? (m0.poster_url || '') : m0.url) : '';
    var ps = r.products || [], states = ps.map(function (p) { return stateOf(p, bags); }).join(''), grp = grpOf(r, states);
    var k = grp ? grpRow(grp) : kindOf(r, bags || '');
    var pimg = ''; ps.some(function (p) { pimg = imgOf(p); return !!pimg; });
    var h = '<button type="button" class="pbr-card' + (img ? ' pbr-card--photo' : '') + (grp ? ' pbr-card--grp' : '') + '" data-id="' + esc(r.id) + '" data-k="' + k + '" data-rating="' + (rated ? esc(r.rating) : '') + '" data-d="' + esc(r.created_at || '') + '"' + (grp ? ' data-grp="' + esc(grp) + '"' : '') + (Object.prototype.hasOwnProperty.call(r, 'category') ? ' data-cat="' + esc(r.category == null ? 'null' : r.category) + '"' : '') + ' aria-label="Open review by ' + esc(who) + '">';
    if (img) h += '<img class="pbr-card__img" src="' + esc(img) + '" alt="' + (m0.kind === 'video' ? 'Video' : 'Photo') + ' from ' + esc(who) + '" width="300" height="300" loading="lazy" decoding="async">';
    h += '<span class="pbr-card__top">' + (rated ? '<span class="pbr-rt" style="--r:' + esc(r.rating) + '" role="img" aria-label="' + esc(r.rating) + ' out of 5 stars"></span>' : '<span class="pbr-card__norate">Written review</span>');
    if (grp) h += '<span class="pbr-grp">' + esc(grp) + '</span>';
    h += '</span>';
    if (r.title && String(r.title).length <= 60) h += '<span class="pbr-card__t">' + esc(r.title) + '</span>';
    if (r.body) h += '<span class="pbr-card__b">' + esc(r.body) + '</span><span class="pbr-more" aria-hidden="true">&hellip; <u>Read more</u></span>'; else if (rated) h += '<span class="pbr-card__b pbr-card__b--muted">Rated ' + esc(r.rating) + ' out of 5</span>';
    if (r.reply) h += '<span class="pbr-reply"><b>Reply from Pinbuds' + (r.reply_at ? ', <time datetime="' + esc(r.reply_at) + '">' + esc(fmtD(r.reply_at)) + '</time>' : '') + '</b><span class="pbr-reply__t">' + esc(r.reply) + '</span></span>';
    if (ps.length) h += '<span class="pbr-prod' + (grp ? ' pbr-prod--off' : '') + '"' + (!grp && ps[0].handle && states.charAt(0) !== '0' ? ' data-pbqv-pill data-url="/products/' + esc(ps[0].handle) + '" role="button" tabindex="0" aria-label="Preview ' + esc(ps[0].title) + '"' : '') + '>' + (pimg ? '<img src="' + esc(pimg) + '" alt="" width="24" height="24" loading="lazy" decoding="async">' : '') + '<span>' + ps.slice(0, 2).map(function (p) { return esc(p.title); }).join(', ') + (ps.length > 2 ? ' and ' + (ps.length - 2) + ' more' : '') + '</span></span>';
    h += '<span class="pbr-card__by"><span class="pbr-card__name">' + esc(who) + '</span>' + (r.created_at ? '<time datetime="' + esc(r.created_at) + '">' + esc(fmtD(r.created_at)) + '</time>' : '') + (r.incentivised ? '<span class="pbr-inc">Incentivised review</span>' : '') + '</span>';
    h += '<span hidden data-media>' + (r.media || []).map(function (x) { return '<i data-u="' + esc(x.url) + '" data-k="' + esc(x.kind) + '" data-p="' + esc(x.poster_url || '') + '" data-w="' + esc(x.width || '') + '" data-h="' + esc(x.height || '') + '"></i>'; }).join('') + '</span>';
    h += '<span hidden data-prods>' + ps.map(function (p, i) { return '<i data-h="' + esc(p.handle) + '" data-t="' + esc(p.title) + '" data-g="' + esc(pid(p)) + '" data-l="' + states.charAt(i) + '" data-i="' + esc(imgOf(p)) + '"></i>'; }).join('') + '</span>';
    return h + '</button>';
  }
  function spotOK(r) { return r.rating != null && r.rating >= 4 && String(r.body || '').length >= 20; }
  // Live-linked to this row's side, or (no live product) in this row's generic group.
  function rowFit(r, bags, want) {
    var ps = r.products || [], states = ps.map(function (p) { return stateOf(p, bags); }).join(''), g = grpOf(r, states);
    if (g) return grpRow(g) === want ? 'g' : '';
    return ps.some(function (p, i) { if (states.charAt(i) === '0') return false; var isBag = bags.indexOf('|' + pid(p) + '|') > -1; return want === 'b' ? isBag : !isBag; }) ? 'l' : '';
  }

  /* ---------- clamp: the underlined More shows only on text that is cut off ---------- */
  function markClamp(scope) {
    [].forEach.call((scope || document).querySelectorAll('.pbr .pbr-card__b'), function (b) {
      if (!b.offsetParent && !b.getClientRects().length) return; // not laid out (filtered out); checked again later
      b.classList.toggle('is-clamped', b.scrollHeight > b.clientHeight + 2);
    });
  }
  var clampT = 0;
  function clampSoon(scope) { clearTimeout(clampT); clampT = setTimeout(function () { markClamp(scope); }, 60); }

  /* ---------- lightbox (reads the card) ---------- */
  var LB = null, lbCards = [], lbI = 0, lbMi = 0, lbReturn = null;
  function lbBuild() {
    if (LB) return LB;
    LB = document.createElement('div'); LB.className = 'pbr pbr-lb'; LB.setAttribute('role', 'dialog'); LB.setAttribute('aria-modal', 'true'); LB.setAttribute('aria-label', 'Customer review');
    LB.innerHTML = '<div class="pbr-lb__scrim" data-x></div><div class="pbr-lb__panel"><div class="pbr-lb__ctl"><button type="button" class="pbr-lb__btn" data-prev aria-label="Previous review">' + CHEV_L + '</button><button type="button" class="pbr-lb__btn" data-next aria-label="Next review">' + CHEV_R + '</button><button type="button" class="pbr-lb__btn" data-x aria-label="Close">' + CLOSE + '</button></div><div class="pbr-lb__media"></div><div class="pbr-lb__body"></div></div>';
    document.body.appendChild(LB);
    LB.addEventListener('click', function (e) {
      if (e.target.closest('[data-x]')) return lbClose();
      if (e.target.closest('[data-prev]')) return lbShow(lbI - 1, 0);
      if (e.target.closest('[data-next]')) return lbShow(lbI + 1, 0);
      if (e.target.closest('[data-mprev]')) return lbShow(lbI, lbMi - 1);
      if (e.target.closest('[data-mnext]')) return lbShow(lbI, lbMi + 1);
      if (e.target.closest('[data-zoom]')) return zmOpen(lbCards[lbI], lbMi);
      var t = e.target.closest('[data-mi]'); if (t) lbShow(lbI, +t.dataset.mi);
    });
    document.addEventListener('keydown', function (e) {
      if (!LB.classList.contains('is-open') || (ZM && ZM.classList.contains('is-open'))) return;
      if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowLeft') lbShow(lbI - 1, 0); else if (e.key === 'ArrowRight') lbShow(lbI + 1, 0);
      else if (e.key === 'Tab') trap(e, LB);
    });
    return LB;
  }
  function trap(e, box) {
    var f = [].slice.call(box.querySelectorAll('button,a[href],input,select,textarea,video[controls]')).filter(function (x) { return !x.hidden && x.offsetParent !== null; });
    if (!f.length) return; var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function lbShow(i, mi) {
    if (!lbCards.length) return;
    var ni = (i + lbCards.length) % lbCards.length;
    if (ni !== lbI || !LB.classList.contains('is-open')) LB.querySelector('.pbr-lb__body').scrollTop = 0;
    lbI = ni;
    var c = lbCards[lbI], media = [].slice.call(c.querySelectorAll('[data-media] i'));
    lbMi = media.length ? ((mi || 0) + media.length) % media.length : 0;
    var m = media[lbMi];
    LB.querySelector('.pbr-lb__panel').classList.toggle('no-media', !media.length);
    var box = LB.querySelector('.pbr-lb__media'), mh = '';
    if (m) {
      var u = m.getAttribute('data-u'), who = (c.querySelector('.pbr-card__name') || {}).textContent || 'a customer';
      mh = m.getAttribute('data-k') === 'video'
        ? '<video src="' + esc(u) + '" poster="' + esc(m.getAttribute('data-p')) + '" controls playsinline preload="none"' + (m.getAttribute('data-w') ? ' width="' + esc(m.getAttribute('data-w')) + '" height="' + esc(m.getAttribute('data-h')) + '"' : '') + '></video>'
        : '<button type="button" class="pbr-lb__zoom" data-zoom aria-label="Open photo full screen"><img src="' + esc(u) + '" alt="Photo from ' + esc(who) + '" decoding="async" fetchpriority="high"></button>';
      if (media.length > 1) mh += '<button type="button" class="pbr-lb__mnav pbr-lb__mnav--prev" data-mprev aria-label="Previous photo">' + CHEV_L + '</button><button type="button" class="pbr-lb__mnav pbr-lb__mnav--next" data-mnext aria-label="Next photo">' + CHEV_R + '</button><span class="pbr-lb__count">' + (lbMi + 1) + ' of ' + media.length + '</span>';
    }
    box.innerHTML = mh; box.hidden = !m;
    LB.querySelector('.pbr-lb__panel').classList.toggle('has-video', !!(m && m.getAttribute('data-k') === 'video'));
    var th = media.length > 1 ? '<div class="pbr-lb__thumbs">' + media.map(function (x, k) { var t = x.getAttribute('data-k') === 'video' ? x.getAttribute('data-p') : x.getAttribute('data-u'); return '<button type="button" data-mi="' + k + '" aria-label="Media ' + (k + 1) + '"' + (k === lbMi ? ' aria-current="true"' : '') + '>' + (t ? '<img src="' + esc(t) + '" alt="" width="48" height="48">' : 'Video') + '</button>'; }).join('') + '</div>' : '';
    var unknown = [];
    var prods = [].slice.call(c.querySelectorAll('[data-prods] i')).filter(function (p) { return p.getAttribute('data-h') || p.getAttribute('data-t'); }).map(function (p) {
      var h = p.getAttribute('data-h'), l = p.getAttribute('data-l'), t = esc(p.getAttribute('data-t')), im = p.getAttribute('data-i');
      if ((l === '?' || l === '') && h) { if (LV[h] === 1) l = '1'; else if (LV[h] === 0) l = '0'; else unknown.push(h); }
      if (l === '1') return '<a class="pbr-lb__prod" href="/products/' + encodeURIComponent(h) + '">' + (im ? '<img src="' + esc(im) + '" alt="" width="56" height="56">' : '') + '<span><strong>' + t + '</strong><em>View product</em></span></a>';
      return '<div class="pbr-lb__prod pbr-lb__prod--off">' + (im ? '<img src="' + esc(im) + '" alt="" width="56" height="56">' : '') + '<span><strong>' + t + '</strong></span></div>';
    }).join('');
    if (unknown.length) { var at = lbI; ensureLive(unknown).then(function () { if (LB.classList.contains('is-open') && lbI === at && unknown.some(function (h) { return LV[h] !== undefined; })) { settleCards(c.parentNode || document); lbShow(lbI, lbMi); } }); }
    // The lightbox never carries the group label (Pin / Bag / Accessory reviews / Reviews); rows and grids keep it.
    var pick = function (sel) { var el = c.querySelector(sel); if (!el) return ''; el = el.cloneNode(true); [].forEach.call(el.querySelectorAll('.pbr-grp, .pbr-more'), function (g) { g.remove(); }); return el.outerHTML; };
    LB.querySelector('.pbr-lb__body').innerHTML = pick('.pbr-card__top') + pick('.pbr-card__t') + pick('.pbr-card__b') + th + pick('.pbr-reply') + pick('.pbr-card__by').replace('pbr-card__by', 'pbr-lb__by') + prods;
    var one = lbCards.length < 2; LB.querySelector('[data-prev]').hidden = one; LB.querySelector('[data-next]').hidden = one;
  }
  /* ---------- full-screen photo (from the lightbox photo); opacity/visibility only, no transform ---------- */
  var ZM = null, zmList = [], zmI = 0, zmX = null;
  function zmBuild() {
    if (ZM) return ZM;
    ZM = document.createElement('div'); ZM.className = 'pbr pbr-zm'; ZM.setAttribute('role', 'dialog'); ZM.setAttribute('aria-modal', 'true'); ZM.setAttribute('aria-label', 'Review photo');
    ZM.innerHTML = '<div class="pbr-zm__stage" data-zx><img alt=""></div><button type="button" class="pbr-zm__btn pbr-zm__x" data-zx aria-label="Close photo">' + CLOSE + '</button><button type="button" class="pbr-zm__btn pbr-zm__prev" data-zp aria-label="Previous photo">' + CHEV_L + '</button><button type="button" class="pbr-zm__btn pbr-zm__next" data-zn aria-label="Next photo">' + CHEV_R + '</button><span class="pbr-zm__count" aria-live="polite"></span>';
    document.body.appendChild(ZM);
    ZM.addEventListener('click', function (e) {
      if (e.target.closest('[data-zp]')) return zmShow(zmI - 1);
      if (e.target.closest('[data-zn]')) return zmShow(zmI + 1);
      if (e.target.tagName !== 'IMG' && e.target.closest('[data-zx]')) zmClose();
    });
    ZM.addEventListener('touchstart', function (e) { zmX = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    ZM.addEventListener('touchend', function (e) { if (zmX == null || zmList.length < 2) return; var dx = e.changedTouches[0].clientX - zmX; zmX = null; if (Math.abs(dx) > 40) zmShow(zmI + (dx < 0 ? 1 : -1)); }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!ZM.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.stopPropagation(); zmClose(); } else if (e.key === 'ArrowLeft') zmShow(zmI - 1); else if (e.key === 'ArrowRight') zmShow(zmI + 1);
      else if (e.key === 'Tab') trap(e, ZM);
    });
    return ZM;
  }
  function zmShow(i) {
    if (!zmList.length) return;
    zmI = (i + zmList.length) % zmList.length;
    var img = ZM.querySelector('img'); img.src = zmList[zmI].u; img.alt = zmList[zmI].a;
    var many = zmList.length > 1;
    ZM.querySelector('[data-zp]').hidden = !many; ZM.querySelector('[data-zn]').hidden = !many;
    ZM.querySelector('.pbr-zm__count').textContent = many ? (zmI + 1) + ' of ' + zmList.length : '';
  }
  function zmOpen(c, mi) {
    if (!c) return;
    zmBuild();
    var who = (c.querySelector('.pbr-card__name') || {}).textContent || 'a customer', all = [].slice.call(c.querySelectorAll('[data-media] i')), start = 0;
    zmList = [];
    all.forEach(function (x, k) { if (x.getAttribute('data-k') === 'video') return; if (k === mi) start = zmList.length; zmList.push({ u: x.getAttribute('data-u'), a: 'Photo from ' + who }); });
    if (!zmList.length) return;
    zmShow(start);
    ZM.classList.add('is-open');
    var b = ZM.querySelector('.pbr-zm__x'); if (b) b.focus({ preventScroll: true });
  }
  function zmClose() {
    if (!ZM || !ZM.classList.contains('is-open')) return;
    ZM.classList.remove('is-open');
    // back on the photo it came from, in step with the photo shown last
    if (LB && LB.classList.contains('is-open')) { var c = lbCards[lbI], all = c ? [].slice.call(c.querySelectorAll('[data-media] i')) : [], u = zmList[zmI] && zmList[zmI].u, k = -1; all.some(function (x, j) { if (x.getAttribute('data-u') === u) { k = j; return true; } return false; }); if (k > -1 && k !== lbMi) lbShow(lbI, k); var z = LB.querySelector('[data-zoom]'); if (z) z.focus({ preventScroll: true }); }
  }
  function lbOpen(card) {
    lbBuild();
    var scope = card.closest('.pbr-row, .pbr-grid, .pbr-mas') || document;
    lbCards = [].slice.call(scope.querySelectorAll('.pbr-card')).filter(function (x) { return !x.hidden; });
    if (scope.classList && scope.classList.contains('pbr-mas')) lbCards.sort(function (x, y) { return (+x.getAttribute('data-o') || 0) - (+y.getAttribute('data-o') || 0); }); //  reading order, not column order
    lbReturn = card;
    lbShow(Math.max(0, lbCards.indexOf(card)), 0);
    document.documentElement.classList.add('pbr-locked');
    LB.classList.add('is-open');
    var b = LB.querySelector('.pbr-lb__btn[data-x]'); if (b) b.focus({ preventScroll: true });
  }
  function lbClose() {
    if (!LB) return;
    zmClose();
    LB.classList.remove('is-open');
    document.documentElement.classList.remove('pbr-locked');
    var v = LB.querySelector('video'); if (v) try { v.pause(); } catch (e) {}
    if (lbReturn && lbReturn.focus) try { lbReturn.focus({ preventScroll: true }); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('.pbr .pbr-card'); if (c && !e.target.closest('.pbr-lb')) lbOpen(c);
  });
  window.addEventListener('pagehide', function () { document.documentElement.classList.remove('pbr-locked'); });
  document.addEventListener('shopify:section:unload', function () { document.documentElement.classList.remove('pbr-locked'); });

  /* ---------- rows ---------- */
  // (7 Oct 2026): homepage wall rows are one carousel of columns at every width. The bento cards join
  // the front of the row's track; cards are packed into columns by measured height (one photo review, or up to
  // three short / two medium text reviews), all columns the same height. Arrows sit in the row heading, so they
  // are never clipped. Re-packed when the column width changes, after Show more, and after a filter chip.
  function colWall(root) {
    if (!root.classList.contains('pbr-wall') && !root.classList.contains('pbr-pdp')) return; // product pages: same compact columns, arrows in the row heading
    root.classList.add('pbr-wall--cols');
    [].forEach.call(root.querySelectorAll('.pbr-row'), function (row) {
      var bento = row.querySelector('.pbr-bento'), track = row.querySelector('.pbr-track'), head = row.querySelector('.pbr-row__head'); if (!track) return;
      if (bento) { var first = track.firstChild; [].forEach.call(bento.querySelectorAll('.pbr-card'), function (c) { track.insertBefore(c, first); }); bento.hidden = true; }
      var prev = row.querySelector('.pbr-nav--prev'), next = row.querySelector('.pbr-nav--next');
      if (head && prev && next && !head.querySelector('.pbr-row__nav')) { var nv = document.createElement('div'); nv.className = 'pbr-row__nav'; nv.appendChild(prev); nv.appendChild(next); head.appendChild(nv); }
      pack(row);
    });
    window.addEventListener('resize', function () { clearTimeout(root._pbrRz); root._pbrRz = setTimeout(function () { [].forEach.call(root.querySelectorAll('.pbr-row'), function (row) { if (row._pbrKey !== colKey(row)) pack(row); }); }, 150); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { [].forEach.call(root.querySelectorAll('.pbr-row'), function (row) { pack(row); }); });
  }
  //  product pills read the product's live title (the review payload keeps the title from when it was
  // published). Bag titles come from the page (cfg.titles); other handles from /products/<handle>.js, 40 at most.
  var TITLES = {};
  function seedTitles(root) { var cfg = cfgOf(root); if (cfg && cfg.titles) for (var h in cfg.titles) if (cfg.titles[h]) TITLES[h] = cfg.titles[h]; }
  function applyTitles(scope) {
    [].forEach.call(scope.querySelectorAll('.pbr-card'), function (card) {
      var is = [].slice.call(card.querySelectorAll('[data-prods] i')), changed = false;
      is.forEach(function (i) { var t = TITLES[i.getAttribute('data-h')]; if (t && i.getAttribute('data-t') !== t) { i.setAttribute('data-t', t); changed = true; } });
      if (!changed) return;
      var ts = is.map(function (i) { return i.getAttribute('data-t') || ''; }).filter(Boolean), sp = card.querySelector('.pbr-prod > span');
      if (sp && ts.length) sp.textContent = ts.slice(0, 2).join(', ') + (ts.length > 2 ? ' and ' + (ts.length - 2) + ' more' : '');
      var pill = card.querySelector('.pbr-prod[aria-label]'); if (pill && ts.length) pill.setAttribute('aria-label', 'Preview ' + ts[0]);
    });
  }
  function retitle(scope) {
    applyTitles(scope);
    var hs = [];
    [].forEach.call(scope.querySelectorAll('[data-prods] i[data-h]'), function (i) { var h = i.getAttribute('data-h'); if (h && /^[a-z0-9][a-z0-9-]*$/i.test(h) && TITLES[h] === undefined && hs.indexOf(h) < 0) hs.push(h); });
    hs = hs.slice(0, 40); if (!hs.length) return;
    hs.forEach(function (h) { TITLES[h] = null; });
    Promise.all(hs.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) { if (d && d.title) TITLES[h] = d.title; }).catch(function () {});
    })).then(function () { applyTitles(scope); });
  }
  function colKey(row) { var t = row.querySelector('.pbr-track'); return t ? Math.round(t.clientWidth) + 'x' + window.innerWidth : ''; }
  // onlyNew: keep the columns already built and pack only cards that are not in a column yet (Show more).
  function pack(row, onlyNew) {
    var track = row.querySelector('.pbr-track'); if (!track || !track.offsetParent && !track.getClientRects().length) return;
    var CAP = row.closest('.pbr-wall') ? 3 : 2; // text cards per column: homepage wall 3, product pages 2
    var G = 12, cols = [].slice.call(track.querySelectorAll(':scope > .pbr-col'));
    var all = [].slice.call(track.querySelectorAll('.pbr-card'));
    var loose = all.filter(function (c) { return c.parentNode === track; });
    if (onlyNew && cols.length && row._pbrT) { all = loose; } else { onlyNew = false; }
    var tail = [].slice.call(track.children).filter(function (x) { return !x.classList.contains('pbr-card') && !x.classList.contains('pbr-col'); });
    var vis = all.filter(function (c) { return !c.hidden; }), hid = all.filter(function (c) { return c.hidden; });
    var meas = document.createElement('div'); meas.className = 'pbr-col pbr-col--measure';
    track.insertBefore(meas, track.firstChild);
    vis.forEach(function (c) { meas.appendChild(c); });
    markClamp(meas);
    var items = vis.map(function (c) { return { c: c, h: c.getBoundingClientRect().height, p: c.classList.contains('pbr-card--photo') }; });
    var T = row._pbrT || 0;
    if (!onlyNew) {
      var maxText = 0, maxPhoto = 0;
      items.forEach(function (x) { if (x.p) maxPhoto = Math.max(maxPhoto, x.h); else maxText = Math.max(maxText, x.h); });
      T = Math.ceil(Math.max(maxPhoto, maxText * 2 + G, 240));
      row._pbrT = T;
      cols.forEach(function (c) { c.remove(); });
    }
    var photos = items.filter(function (x) { return x.p; }), texts = items.filter(function (x) { return !x.p; });
    var tcols = [];
    while (texts.length) {
      var col = [texts.shift()], used = col[0].h;
      while (col.length < CAP) {
        var k = -1;
        for (var j = 0; j < Math.min(texts.length, 8); j++) { if (used + G + texts[j].h <= T) { k = j; break; } }
        if (k < 0) break;
        used += G + texts[k].h; col.push(texts.splice(k, 1)[0]);
      }
      tcols.push(col);
    }
    // no lone short card at the end: borrow one card from the nearest full column
    var lc = tcols[tcols.length - 1];
    if (tcols.length > 1 && lc.length === 1) { for (var q = tcols.length - 2; q >= 0; q--) { if (tcols[q].length === CAP && CAP > 2) { lc.unshift(tcols[q].pop()); break; } } }
    var order = [], pi = 0, ti = 0;
    while (pi < photos.length || ti < tcols.length) { if (pi < photos.length) order.push([photos[pi++]]); if (ti < tcols.length) order.push(tcols[ti++]); }
    var anchor = tail[0] || null;
    order.forEach(function (grp) {
      var d = document.createElement('div'); d.className = 'pbr-col'; d.style.minHeight = T + 'px';
      grp.forEach(function (x) { d.appendChild(x.c); });
      track.insertBefore(d, anchor);
    });
    if (hid.length) {
      var hc = track.querySelector(':scope > .pbr-col--hid');
      if (!hc) { hc = document.createElement('div'); hc.className = 'pbr-col pbr-col--hid'; hc.hidden = true; }
      hid.forEach(function (c) { hc.appendChild(c); }); track.insertBefore(hc, anchor);
    }
    var hcEmpty = track.querySelector(':scope > .pbr-col--hid'); if (hcEmpty && !hcEmpty.children.length) hcEmpty.remove();
    meas.remove();
    // all columns the same height (the track stretches them); minHeight keeps photo-only filters even too
    [].forEach.call(track.querySelectorAll(':scope > .pbr-col:not(.pbr-col--hid)'), function (c) { c.style.minHeight = T + 'px'; });
    row._pbrKey = colKey(row);
    markClamp(track);
    if (row._pbrNav) row._pbrNav();
  }
  function rowNav(row) {
    var track = row.querySelector('.pbr-track'), prev = row.querySelector('.pbr-nav--prev'), next = row.querySelector('.pbr-nav--next'), raf = 0;
    if (!track || !prev) return;
    var wrap = track.parentNode;
    function st() { prev.hidden = track.scrollLeft < 8; next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8; wrap.classList.toggle('is-l', !prev.hidden); wrap.classList.toggle('is-r', !next.hidden); }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * .85, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * .85, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; st(); }); }, { passive: true });
    row._pbrNav = st; st();
  }
  function moreCard(row, label) {
    var track = row.querySelector('.pbr-track'); if (!track) return null;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'pbr-more-card'; b.textContent = label || 'Show more';
    track.appendChild(b); if (row._pbrNav) row._pbrNav(); return b;
  }
  function seenIn(root) { var s = {}; [].forEach.call(root.querySelectorAll('.pbr-card[data-id]'), function (c) { s[c.getAttribute('data-id')] = 1; }); return s; }
  function updating(root, msg) {
    var n = root.querySelector('.pbr-note--soft');
    if (!n) { n = document.createElement('p'); n.className = 'pbr-note pbr-note--soft'; n.setAttribute('aria-live', 'polite'); var f = root.querySelector('.pbr-foot'); if (f) f.parentNode.insertBefore(n, f); else (root.querySelector('.pbr__wrap') || root).appendChild(n); }
    n.textContent = msg || 'More reviews are on their way. Please try again in a moment.';
    n.hidden = false;
  }

  function spotlight(root) {
    var cfg = cfgOf(root); if (!cfg) return;
    var bags = cfg.bags || '|';
    [].forEach.call(root.querySelectorAll('.pbr-row'), rowNav);
    // own pages (product), then the row's category
    [].forEach.call(root.querySelectorAll('.pbr-row'), function (row) {
      var want = row.getAttribute('data-row');
      var isOwn = row.hasAttribute('data-own'); // the product's own row loads only its own pages
      var own = isOwn && cfg.own ? { p: cfg.own, next: 2 } : null;
      var bagFeeds = want === 'b' ? (cfg.bagFeed || []).map(function (p) { return { p: p, next: 2 }; }) : [];
      var shopNext = cfg.next || 2;
      if (isOwn && !own) return;
      var btn = moreCard(row, 'Show more');
      if (!btn) return;
      btn.addEventListener('click', function () {
        btn.disabled = true; btn.textContent = 'Loading';
        var seen = seenIn(root), add = [], jobs;
        if (own && own.next <= own.p.pages) {
          jobs = productPage(own.p, own.next).then(function (d) { own.next++; return ensureLiveFor(d.reviews, bags).then(function () { (d.reviews || []).forEach(function (r) { if (!seen[r.id]) { seen[r.id] = 1; add.push(r); } }); }); });
        } else if (isOwn) {
          jobs = Promise.resolve();
        } else if (want === 'b') {
          var src = bagFeeds.filter(function (b) { return b.next <= b.p.pages; })[0];
          jobs = src ? productPage(src.p, src.next).then(function (d) { src.next++; return ensureLiveFor(d.reviews, bags).then(function () { (d.reviews || []).forEach(function (r) { if (!seen[r.id] && spotOK(r) && rowFit(r, bags, 'b')) { seen[r.id] = 1; add.push(r); } }); }); }) : Promise.resolve();
        } else {
          var tries = 0;
          var step = function () {
            if (shopNext > cfg.pages || tries >= 4 || add.length >= 8) return Promise.resolve();
            tries++;
            return shopPage(cfg, shopNext).then(function (d) {
              shopNext++;
              return ensureLiveFor(d.reviews, bags).then(function () {
                (d.reviews || []).forEach(function (r) { if (!seen[r.id] && spotOK(r) && rowFit(r, bags, 'a')) { seen[r.id] = 1; add.push(r); } });
                return step();
              });
            });
          };
          jobs = step();
        }
        jobs.then(function () {
          // live-linked first, then the generic group; photos first within each
          var rank = function (r) { return (grpOf(r, (r.products || []).map(function (p) { return stateOf(p, bags); }).join('')) ? 2 : 0) + ((r.media || []).length ? 0 : 1); };
          add.sort(function (a, b) { return rank(a) - rank(b); });
          btn.insertAdjacentHTML('beforebegin', add.map(function (r) { return card(r, bags); }).join(''));
          if (root.classList.contains('pbr-wall--cols')) pack(row, true);
          retitle(row);
          var left = isOwn ? !!(own && own.next <= own.p.pages) : (want === 'b' ? bagFeeds.some(function (b) { return b.next <= b.p.pages; }) : shopNext <= cfg.pages);
          if (!add.length && !left) btn.remove();
          else if (!left) { if (isOwn) btn.remove(); else btn.outerHTML = '<a class="pbr-more-card" href="/pages/reviews">All reviews</a>'; }
          else { btn.disabled = false; btn.textContent = 'Show more'; }
          if (row._pbrNav) row._pbrNav();
          applyChip(root);
          clampSoon(root);
        }).catch(function (e) {
          btn.disabled = false; btn.textContent = 'Show more';
          if (e && e.status === 503) updating(root, 'More reviews are on their way. Please try again in a moment.');
        });
      });
    });
    var chips = [].slice.call(root.querySelectorAll('[data-chip]'));
    chips.forEach(function (c) { c.addEventListener('click', function () { chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); }); root._chip = c.getAttribute('data-chip'); applyChip(root); }); });    pdpCloud(root, cfg);
  }
  /* ---------- product page word cloud ----------
     The reviews page cloud, counted over the review cards on this product page only (own row plus the
     category rows, recounted after Show more). The index (assets/pb-review-themes.json) is fetched once the
     section nears the viewport. A word filters the cards in place; rows with no match hide; the status line
     gives the count and Clear filters. Phones: one horizontally scrolling row (CSS), bentos show 3 cards
     with a Show more toggle. */
  function cardTheme(root, c) {
    if (!root._th || !TIX) return true;
    var e = TIX.r[rkey(c.getAttribute('data-id'))];
    return !!e && e.indexOf(root._thI, 2) > -1;
  }
  function pdpCloud(root, cfg) {
    var box = root.querySelector('[data-pdp-cloud]');
    if (!box || !cfg.themes) return;
    var ul = box.querySelector('.pbr-cloud');
    root._th = ''; root._thI = -1;
    function count() {
      var cnt = {}, seen = {};
      [].forEach.call(root.querySelectorAll('.pbr-card[data-id]'), function (c) {
        var id = c.getAttribute('data-id'); if (seen[id]) return; seen[id] = 1;
        var e = TIX.r[rkey(id)]; if (!e) return;
        for (var i = 2; i < e.length; i++) cnt[e[i]] = (cnt[e[i]] || 0) + 1;
      });
      return cnt;
    }
    root._pbrCloud = function () {
      if (!TIX) return;
      var cnt = count(), list = Object.keys(cnt).map(Number).sort(function (a, b) { return cnt[b] - cnt[a] || a - b; });
      if (!list.length) { box.hidden = true; return; }
      var max = cnt[list[0]];
      var key = list.map(function (i) { return i + ':' + cnt[i]; }).join(',');
      if (key !== root._cloudKey) {
        root._cloudKey = key;
        ul.innerHTML = list.map(function (i) {
          var t = TIX.t[i], c = cnt[i], r = c / max, tier = r > 0.66 ? 4 : r > 0.4 ? 3 : r > 0.2 ? 2 : 1;
          return '<li><button type="button" class="pbr-word pbr-word--' + tier + '" data-theme="' + esc(t[0]) + '" aria-pressed="' + (t[0] === root._th ? 'true' : 'false') + '" title="' + c + (c === 1 ? ' review mentions' : ' reviews mention') + ' this" data-n="' + c + '">' + esc(t[1]) + '</button></li>';
        }).join('');
      }
      box.hidden = false;
    };
    root.addEventListener('click', function (e) {
      var w = e.target.closest('[data-theme]');
      if (w && box.contains(w)) {
        var k = w.getAttribute('data-theme'); root._th = k === root._th ? '' : k; root._thI = -1;
        if (root._th) TIX.t.some(function (t, i) { if (t[0] === root._th) { root._thI = i; return true; } return false; });
        [].forEach.call(ul.querySelectorAll('[data-theme]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-theme') === root._th ? 'true' : 'false'); });
        applyChip(root); return;
      }
      if (e.target.closest('[data-pdp-clear]')) { root._th = ''; root._thI = -1; [].forEach.call(ul.querySelectorAll('[data-theme]'), function (b) { b.setAttribute('aria-pressed', 'false'); }); applyChip(root); return; }
      var m = e.target.closest('[data-bento-more]');
      if (m) { var bt = m.previousElementSibling; if (bt) bt.classList.add('is-open'); m.hidden = true; }
    });
    themesIndex(cfg.themes).then(function (d) { if (d) { root._pbrCloud(); bento3(root); } });
    bento3(root);
  }
  // phones: a bento shows its first 3 visible cards; the rest sit behind Show more (CSS hides .pbr-x3 at <=749px)
  function bento3(root) {
    if (!root.classList.contains('pbr-pdp')) return;
    [].forEach.call(root.querySelectorAll('.pbr-bento'), function (bt) {
      var k = 0, extra = 0;
      [].forEach.call(bt.querySelectorAll('.pbr-card'), function (c) { if (c.hidden) return; k++; var x = k > 3; c.classList.toggle('pbr-x3', x); if (x && !c.closest('.pbr-bento__x')) extra++; });
      var m = bt.nextElementSibling && bt.nextElementSibling.hasAttribute('data-bento-more') ? bt.nextElementSibling : null;
      if (!m && extra) { m = document.createElement('button'); m.type = 'button'; m.className = 'pbr-pill pbr-pill--ghost pbr-bento__more'; m.setAttribute('data-bento-more', ''); bt.insertAdjacentElement('afterend', m); }
      if (m) { m.textContent = 'Show ' + extra + ' more'; m.hidden = !extra || bt.classList.contains('is-open'); }
    });
  }
  // Filters only ever hide cards that do not match; a row with nothing matching says so.
  function applyChip(root) {
    var f = root._chip || 'all';
    [].forEach.call(root.querySelectorAll('.pbr-row'), function (row) {
      var k = row.getAttribute('data-row'), vis = 0;
      row.hidden = (f === 'b' || f === 'a') && k !== f;
      [].forEach.call(row.querySelectorAll('.pbr-card'), function (c) { c.hidden = (f === 'photos' && !c.classList.contains('pbr-card--photo')) || !cardTheme(root, c); if (!c.hidden) vis++; });
      if (root._th) { row.hidden = row.hidden || !vis; if (root.classList.contains('pbr-wall--cols') && !row.hidden) pack(row); if (row._pbrNav) row._pbrNav(); return; }
      var track = row.querySelector('.pbr-track'), e = row.querySelector('.pbr-empty-row');
      if (!vis && track) { if (!e) { e = document.createElement('p'); e.className = 'pbr-empty-row'; track.insertBefore(e, track.firstChild); } e.textContent = f === 'photos' ? 'Use Show more to load more photo reviews.' : 'Use Show more to load more reviews.'; e.hidden = false; }
      else if (e) e.hidden = true;
      if (root.classList.contains('pbr-wall--cols')) pack(row);
      if (row._pbrNav) row._pbrNav();
    });
    if (root._pbrCloud) {
      root._pbrCloud();
      var st = root.querySelector('[data-status]');
      if (st) {
        st.hidden = !root._th;
        if (root._th && TIX) { var ids = {}, nv = 0; [].forEach.call(root.querySelectorAll('.pbr-card[data-id]'), function (c) { var id = c.getAttribute('data-id'); if (!c.hidden && !ids[id]) { ids[id] = 1; nv++; } }); st.querySelector('span').textContent = nv + (nv === 1 ? ' review' : ' reviews') + ' mentioning \u201c' + TIX.t[root._thI][1] + '\u201d'; }
      }
      bento3(root);
    }
    clampSoon(root);
  }

  /* ---------- full page ---------- */
  // Filters work on the reviews already on the page first (never showing a non-matching card),
  // then swap in the feed's filtered pages. If the feed is unavailable it is retried quietly
  // with backoff; the small note shows only while the feed is needed and failing.
  function fullPage(root) {
    var cfg = cfgOf(root); if (!cfg) return;
    var form = root.querySelector('[data-filters]'), grid = root.querySelector('.pbr-grid'), more = root.querySelector('[data-more]'), status = root.querySelector('[data-status] span'), pager = root.querySelector('[data-pager]');
    var rating = root.querySelector('[name=rating]'), sort = root.querySelector('[name=sort]');
    var bags = cfg.bags || '|', dist = cfg.dist || {}, total = cfg.total;
    var st = { q: '', page: 1, pages: cfg.pages, live: true }, busy = false, retryT = 0, retryN = 0, gen = 0;
    var done = { '': { page: 1, pages: cfg.pages, total: total } }; // feed pages already merged, per query
    var DELAYS = [2000, 4000, 8000, 15000, 30000, 60000];
    var note = document.createElement('p'); note.className = 'pbr-note pbr-note--soft'; note.hidden = true; note.setAttribute('aria-live', 'polite');
    grid.parentNode.insertBefore(note, grid);
    var empty = document.createElement('p'); empty.className = 'pbr-empty'; empty.hidden = true;
    grid.parentNode.insertBefore(empty, grid.nextSibling);
    if (form) form.hidden = false;
    more.hidden = st.pages <= 1;
    function want() { return { r: rating && rating.value ? +rating.value : 0, s: sort && sort.value === 'oldest' ? 'oldest' : 'newest' }; }
    function query() { var w = want(), p = []; if (w.r) p.push('rating=' + w.r); if (w.s !== 'newest') p.push('sort=' + w.s); return p.length ? '?' + p.join('&') : ''; }
    function n(v) { return Number(v || 0).toLocaleString('en-US'); }
    // show only matching cards, in the chosen order
    function applyLocal() {
      var w = want(), cards = [].slice.call(grid.querySelectorAll('.pbr-card')), vis = 0;
      cards.sort(function (a, b) { var x = a.getAttribute('data-d') || '', y = b.getAttribute('data-d') || ''; return w.s === 'oldest' ? (x < y ? -1 : x > y ? 1 : 0) : (x < y ? 1 : x > y ? -1 : 0); });
      cards.forEach(function (c) { grid.appendChild(c); c.hidden = !!w.r && +c.getAttribute('data-rating') !== w.r; if (!c.hidden) vis++; });
      clampSoon(root);
      if (!vis && w.r) {
        var tot = dist[String(w.r)];
        empty.textContent = st.live && st.q === query() && !busy ? 'No ' + w.r + '-star reviews.' : 'No ' + w.r + '-star reviews loaded yet.' + (tot != null ? ' ' + n(tot) + ' in total.' : '');
        empty.hidden = false;
      } else empty.hidden = true;
      return vis;
    }
    function setStatus(vis, d) {
      var w = want();
      var of = d && d.total != null ? d.total : (w.r ? dist[String(w.r)] : total);
      status.textContent = 'Showing ' + n(vis) + (of != null ? ' of ' + n(of) : '') + (w.r ? ' ' + w.r + '-star reviews' : ' reviews');
    }
    function stopRetry() { clearTimeout(retryT); retryT = 0; }
    function fail(e, n2, myGen) {
      if (myGen !== gen) return;
      st.live = false;
      note.textContent = 'Showing the reviews already loaded. The full list will appear here as soon as it is ready.';
      note.hidden = false;
      setStatus(applyLocal());
      more.hidden = true;
      if (retryN < DELAYS.length) { stopRetry(); retryT = setTimeout(function () { retryN++; load(n2, true); }, DELAYS[retryN]); }
    }
    function load(pageN, quiet) {
      if (busy) return; busy = true; more.disabled = true;
      var myGen = gen, q = query();
      shopPage(cfg, pageN, q).then(function (d) {
        if (myGen !== gen) return;
        return ensureLiveFor(d.reviews, bags).then(function () {
          if (myGen !== gen) return;
          if (cfg.reset) cfg.reset = false;
          var seen = seenIn(grid);
          var html = (d.reviews || []).filter(function (r) { return !seen[r.id]; }).map(function (r) { return card(r, bags); }).join('');
          grid.insertAdjacentHTML('beforeend', html);
          st.q = q; st.page = d.page || pageN; st.pages = d.page_count || 0; st.live = true; retryN = 0; stopRetry();
          done[q] = { page: st.page, pages: st.pages, total: d.total };
          note.hidden = true;
          more.hidden = st.page >= st.pages;
          setStatus(applyLocal(), d);
          if (pager) pager.hidden = true;
        });
      }).catch(function (e) { fail(e, pageN, myGen); }).then(function () { busy = false; more.disabled = false; if (myGen === gen) applyLocal(); });
    }
    function changed() {
      gen++; stopRetry(); retryN = 0; busy = false;
      var q = query(), had = done[q];
      if (pager) pager.hidden = !!q;
      if (had) {
        // this view is already complete on the page: no feed needed
        st.q = q; st.page = had.page; st.pages = had.pages; st.live = true; note.hidden = true;
        more.hidden = st.page >= st.pages;
        setStatus(applyLocal(), { total: had.total });
        return;
      }
      st.q = null; st.page = 0; more.hidden = true;
      setStatus(applyLocal());
      load(1, false);
    }
    if (rating) rating.addEventListener('change', changed);
    if (sort) sort.addEventListener('change', changed);
    more.addEventListener('click', function () { load(st.q === query() ? st.page + 1 : 1, false); });
    window.addEventListener('pagehide', stopRetry);
    root._pbrApply = applyLocal;
  }

  /* --------- reviews page: word cloud, photo carousels, written reviews ----------
     One model for the three groups (Bag reviews = bag photo reviews, Accessory reviews = other photo reviews,
     Written reviews = text-only reviews). Reviews come from the public feed, newest first, 25 to a page.
     assets/pb-review-themes.json (scripts/review-themes.py) maps each review id to its feed page, flags and
     themes, so a group or filter fetches only the pages that hold matches and knows its total. If the index is
     missing every page is a candidate (themes then cannot filter, so the cloud hides). Each group shows a
     growing prefix: rows 12 at a time from their end card, written reviews one batch at a time (Load more,
     the first three batches also load on scroll). Pages are fetched 4 at a time and kept for the visit. */
  var TIX = null, tixLoad = null, PENDING_THEME = null;
  function themesIndex(url) {
    if (tixLoad) return tixLoad;
    tixLoad = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { if (!d || !d.r || !d.t) throw new Error('bad index'); TIX = d; return d; })
      .catch(function () { tixLoad = null; return null; });
    return tixLoad;
  }
  function rkey(id) { return String(id || '').slice(2, 14); }
  function hub(root) {
    var cfg = cfgOf(root); if (!cfg) return;
    var bags = cfg.bags || '|', P = cfg.pages || 1, BATCH = cfg.batch || 24, ROWN = 12;
    var inOv = !!root.closest('.pbr-ov');
    var secs = {}; ['b', 'a', 't'].forEach(function (k) { secs[k] = root.querySelector('[data-hub="' + k + '"]'); });
    var mas = root.querySelector('[data-hub-mas]'), more = root.querySelector('[data-more]'), pager = root.querySelector('[data-pager]');
    var form = root.querySelector('[data-filters]'), rating = root.querySelector('[name=rating]'), sort = root.querySelector('[name=sort]');
    var status = root.querySelector('[data-status]'), empty = root.querySelector('[data-hub-empty]'), cloud = root.querySelector('[data-hub-cloud]');
    var st = { g: 'all', r: 0, s: 'newest', th: '' }, gen = 0, auto = 0;
    var PG = {}, inflight = {}, queue = [], running = 0;
    var view = { b: { want: ROWN, ids: [] }, a: { want: ROWN, ids: [] }, t: { want: BATCH, ids: [] } };
    var thIdx = -1, idxOK = false;
    if (form) form.hidden = false;
    if (pager) pager.hidden = true; // the feed replaces paging once the script runs
    function n(v) { return Number(v || 0).toLocaleString('en-US'); }
    function isBag(r) { if (r.category === 'bag') return true; return (r.products || []).some(function (p) { return bags.indexOf('|' + pid(p) + '|') > -1; }); }
    function photo(r) { return (r.media || []).length > 0; }
    function written(r) { return String(r.body || '').trim() !== ''; }
    function inSec(k, r) { return k === 't' ? !photo(r) && written(r) : photo(r) && (k === 'b') === isBag(r); }
    function secOn(k) { return st.g === 'all' || (st.g === 'photos' ? k !== 't' : k === 't' || k === st.g); }
    function passes(r) {
      if (st.g === 'b' && !isBag(r)) return false;
      if (st.g === 'a' && isBag(r)) return false;
      if (st.r && +r.rating !== st.r) return false;
      if (thIdx > -1) { var e = TIX && TIX.r[rkey(r.id)]; if (!e || e.indexOf(thIdx, 2) < 0) return false; }
      return true;
    }
    // index entry: [page, flags, theme...]; flags photo 1, bag 2, written 4, rating << 3
    function eMatch(k, e) {
      var f = e[1], ph = f & 1, bg = f & 2, wr = f & 4;
      if (k === 't' ? (ph || !wr) : (!ph || (k === 'b') !== !!bg)) return false;
      if (st.g === 'b' && !bg) return false;
      if (st.g === 'a' && bg) return false;
      if (st.r && (f >> 3) !== st.r) return false;
      if (thIdx > -1 && e.indexOf(thIdx, 2) < 0) return false;
      return true;
    }
    var cand = {}, tot = {};
    function plan() {
      ['b', 'a', 't'].forEach(function (k) {
        var set = {}, c = 0;
        if (TIX) for (var id in TIX.r) { var e = TIX.r[id]; if (eMatch(k, e)) { c++; set[e[0]] = 1; } }
        var list = [];
        if (idxOK) { for (var p in set) list.push(+p); list.sort(function (x, y) { return x - y; }); }
        else for (var i = 1; i <= P; i++) list.push(i);
        if (st.s === 'oldest') list.reverse();
        cand[k] = list; tot[k] = TIX ? c : null;
      });
    }
    function fetchPage(p) {
      if (PG[p]) return Promise.resolve(PG[p]);
      if (inflight[p]) return inflight[p];
      inflight[p] = new Promise(function (res, rej) { queue.push({ p: p, res: res, rej: rej }); pump(); });
      inflight[p].then(null, function () {}).then(function () { delete inflight[p]; });
      return inflight[p];
    }
    function pump() {
      while (running < 4 && queue.length) {
        (function (job) {
          running++;
          shopPage(cfg, job.p).then(function (d) {
            if (cfg.reset) { cfg.reset = false; PG = {}; P = cfg.pages; idxOK = !!(TIX && TIX.pub === cfg.pub); }
            PG[job.p] = d.reviews || []; job.res(PG[job.p]);
          }, job.rej).then(function () { running--; pump(); });
        })(queue.shift());
      }
    }
    // the matching reviews of group k from its candidate pages, in order, as far as pages are loaded
    function collect(k) {
      var out = [], list = cand[k] || [], need = view[k].want + 1, reachedEnd = true, missing = [];
      for (var i = 0; i < list.length; i++) {
        var rs = PG[list[i]];
        if (!rs) { reachedEnd = false; missing = list.slice(i, i + 4); break; }
        if (st.s === 'oldest') rs = rs.slice().reverse();
        for (var j = 0; j < rs.length; j++) { var r = rs[j]; if (inSec(k, r) && passes(r)) out.push(r); }
        if (out.length >= need) { reachedEnd = i === list.length - 1; break; }
      }
      return { list: out, done: reachedEnd && out.length < need, missing: out.length >= need ? [] : missing };
    }
    function cardsHTML(rs) { return rs.map(function (r) { return card(r, bags); }).join(''); }
    function after(scope) { applyTitles(scope); settleCards(scope); clampSoon(scope); }
    function metaFor(k, shown, done) {
      var el = secs[k] && secs[k].querySelector('[data-hub-n]'); if (!el) return;
      var t = tot[k] != null ? tot[k] : (done ? shown : null);
      el.textContent = t != null ? n(t) + (t === 1 ? ' review' : ' reviews') : '';
    }
    function renderRow(k, res) {
      var sec = secs[k], track = sec.querySelector('.pbr-track'), v = view[k];
      var show = res.list.slice(0, v.want), ids = show.map(function (r) { return r.id; });
      var same = v.ids.length && v.ids.every(function (id, i) { return ids[i] === id; });
      var mc = track.querySelector('.pbr-more-card'); if (mc) mc.remove();
      if (same && ids.length >= v.ids.length) track.insertAdjacentHTML('beforeend', cardsHTML(show.slice(v.ids.length)));
      else { track.innerHTML = cardsHTML(show); track.scrollLeft = 0; }
      v.ids = ids;
      var left = res.list.length > v.want || !res.done;
      if (left) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pbr-more-card'; b.textContent = 'Show more';
        b.addEventListener('click', function () { if (b.disabled) return; b.disabled = true; b.textContent = 'Loading'; v.want += ROWN; fill(k, gen); });
        track.appendChild(b);
        rowAuto(sec, b);
      }
      sec.hidden = !secOn(k) || (!show.length && res.done);
      metaFor(k, show.length, res.done && !left);
      after(track);
      if (sec._pbrNav) sec._pbrNav();
    }
    // a row's end card loads more when it scrolls into view inside the row
    function rowAuto(sec, b) {
      if (!('IntersectionObserver' in window)) return;
      var track = sec.querySelector('.pbr-track');
      var io = new IntersectionObserver(function (en) { if (en.some(function (e) { return e.isIntersecting; })) { io.disconnect(); if (b.isConnected && !b.disabled) b.click(); } }, { root: track, rootMargin: '0px 300px 0px 0px' });
      // only once the visitor has moved the row (never on first paint)
      track.addEventListener('scroll', function once() { track.removeEventListener('scroll', once); if (b.isConnected) io.observe(b); }, { passive: true });
    }
    var cols = [], colN = 0, masIds = [];
    function colCount() { var w = mas.clientWidth || root.clientWidth; return w >= 940 ? 3 : w >= 600 ? 2 : 1; }
    function masReset() {
      colN = colCount(); mas.innerHTML = ''; mas.classList.add('is-js'); cols = [];
      for (var i = 0; i < colN; i++) { var c = document.createElement('div'); c.className = 'pbr-mas__col'; mas.appendChild(c); cols.push(c); }
      masIds = [];
    }
    function masAdd(rs) {
      var tmp = document.createElement('div'); tmp.innerHTML = cardsHTML(rs);
      var hs = cols.map(function (c) { return c.offsetHeight; });
      [].slice.call(tmp.children).forEach(function (c) {
        var m = 0; for (var i = 1; i < hs.length; i++) if (hs[i] < hs[m] - 1) m = i;
        c.setAttribute('data-o', masIds.length); cols[m].appendChild(c); masIds.push(c.getAttribute('data-id'));
        hs[m] += c.offsetHeight + 14;
      });
      after(mas);
    }
    function renderText(k, res) {
      var sec = secs.t, v = view.t, show = res.list.slice(0, v.want), ids = show.map(function (r) { return r.id; });
      var same = masIds.length && cols.length === colCount() && masIds.every(function (id, i) { return ids[i] === id; });
      if (same && ids.length >= masIds.length) masAdd(show.slice(masIds.length));
      else { masReset(); masAdd(show); }
      v.ids = ids;
      var left = res.list.length > v.want || !res.done;
      more.hidden = !left; more.disabled = false; more.textContent = 'Load more';
      sec.hidden = !secOn('t') || (!show.length && res.done);
      metaFor('t', show.length, res.done && !left);
    }
    function fill(k, g) {
      if (g !== gen) return Promise.resolve();
      var res = collect(k);
      if (res.missing.length) {
        var busy = secs[k]; if (busy) busy.setAttribute('aria-busy', 'true');
        return Promise.all(res.missing.map(fetchPage)).then(function () { return fill(k, g); }, function (e) {
          if (g !== gen) return;
          if (busy) busy.removeAttribute('aria-busy');
          // feed unavailable: show what is loaded and say so quietly
          var r2 = collect(k); r2.done = true; (k === 't' ? renderText : renderRow)(k, r2);
          updating(root, 'More reviews are on their way. Please try again in a moment.');
        });
      }
      if (secs[k]) secs[k].removeAttribute('aria-busy');
      (k === 't' ? renderText : renderRow)(k, res);
      if (res.list.length || !res.done) any = true;
      return Promise.resolve();
    }
    var any = false;
    function refresh() {
      gen++; any = false; auto = 0;
      view.b.want = ROWN; view.a.want = ROWN; view.t.want = BATCH;
      plan();
      var g = gen;
      ['b', 'a', 't'].forEach(function (k) { if (secs[k]) secs[k].hidden = !secOn(k); });
      return Promise.all(['b', 'a', 't'].filter(secOn).map(function (k) { return fill(k, g); })).then(function () {
        if (g !== gen) return;
        var shown = ['b', 'a', 't'].some(function (k) { return secs[k] && !secs[k].hidden; });
        if (empty) empty.hidden = shown;
        say();
      });
    }
    function say() {
      if (!status) return;
      var active = st.g !== 'all' || st.r || st.th;
      status.hidden = !active;
      if (!active) return;
      var c = ['b', 'a', 't'].filter(secOn).reduce(function (s2, k) { return tot[k] != null ? s2 + tot[k] : s2; }, 0);
      var txt = { b: 'bag reviews', a: 'accessory reviews', photos: 'reviews with photos' }[st.g] || 'reviews';
      if (st.r) txt += ', ' + st.r + (st.r === 1 ? ' star' : ' stars');
      if (thIdx > -1 && TIX && TIX.t[thIdx]) txt += ' mentioning \u201c' + TIX.t[thIdx][1] + '\u201d';
      txt = TIX ? n(c) + ' ' + txt : txt.charAt(0).toUpperCase() + txt.slice(1);
      status.querySelector('span').textContent = txt;
    }
    function setTheme(key) {
      st.th = key || '';
      thIdx = -1;
      if (st.th && TIX) TIX.t.some(function (t, i) { if (t[0] === st.th) { thIdx = i; return true; } return false; });
      if (st.th && thIdx < 0) st.th = '';
      [].forEach.call(root.querySelectorAll('[data-theme]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-theme') === st.th ? 'true' : 'false'); });
      if (!inOv) { try { var u = new URL(location.href); if (st.th) u.searchParams.set('theme', st.th); else u.searchParams.delete('theme'); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {} }
    }
    function setG(g) { st.g = g; [].forEach.call(root.querySelectorAll('[data-hub-g]'), function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-hub-g') === g ? 'true' : 'false'); }); }
    root.addEventListener('click', function (e) {
      var w = e.target.closest('[data-theme]');
      if (w && root.contains(w)) { setTheme(w.getAttribute('data-theme') === st.th ? '' : w.getAttribute('data-theme')); refresh(); return; }
      var c = e.target.closest('[data-hub-g]');
      if (c) { setG(c.getAttribute('data-hub-g')); refresh(); return; }
      if (e.target.closest('[data-hub-clear]')) { setG('all'); setTheme(''); if (rating) rating.value = ''; if (sort) sort.value = 'newest'; st.r = 0; st.s = 'newest'; refresh(); }
    });
    if (rating) rating.addEventListener('change', function () { st.r = rating.value ? +rating.value : 0; refresh(); });
    if (sort) sort.addEventListener('change', function () { st.s = sort.value === 'oldest' ? 'oldest' : 'newest'; refresh(); });
    more.addEventListener('click', function () { if (more.disabled) return; more.disabled = true; more.textContent = 'Loading'; view.t.want += BATCH; fill('t', gen); });
    if ('IntersectionObserver' in window) {
      var mio = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; }) && !more.hidden && !more.disabled && auto < 3 && mas.classList.contains('is-js')) { auto++; more.click(); } }, { rootMargin: '400px 0px' });
      mio.observe(more);
    }
    window.addEventListener('resize', function () { clearTimeout(root._hubRz); root._hubRz = setTimeout(function () { if (mas.classList.contains('is-js') && colCount() !== cols.length) fill('t', gen); }, 150); }, { passive: true });
    [].forEach.call(root.querySelectorAll('.pbr-hub__row'), rowNav);
    root._pbrSetTheme = function (k) { setTheme(k); refresh(); };
    // start: the index first (counts, themes), then the first view from the feed
    var want0 = PENDING_THEME; PENDING_THEME = null;
    if (!want0 && !inOv) { try { want0 = new URL(location.href).searchParams.get('theme') || ''; } catch (e) { want0 = ''; } }
    themesIndex(cfg.themes).then(function (d) {
      idxOK = !!(d && d.pub === cfg.pub && d.pages === P);
      if (!d && cloud) cloud.hidden = true;
      if (want0) setTheme(want0);
      // keep the server-rendered first view on screen until the feed answers
      refresh();
    });
  }

  /* ---------- write a review (inert until the Pinbuds review tool is connected) ---------- */
  var SH = null, shReturn = null;
  function shOpen(ctx, from) {
    if (!SH) {
      SH = document.createElement('div'); SH.className = 'pbr pbr-sheet'; SH.setAttribute('role', 'dialog'); SH.setAttribute('aria-modal', 'true'); SH.setAttribute('aria-labelledby', 'pbr-sheet-h');
      SH.innerHTML = '<div class="pbr-sheet__scrim" data-x></div><div class="pbr-sheet__panel"><button type="button" class="pbr-lb__btn pbr-sheet__x" data-x aria-label="Close">' + CLOSE + '</button><div data-body></div></div>';
      document.body.appendChild(SH);
      SH.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) shClose(); });
      document.addEventListener('keydown', function (e) { if (!SH.classList.contains('is-open')) return; if (e.key === 'Escape') { e.preventDefault(); shClose(); } else if (e.key === 'Tab') trap(e, SH); });
    }
    shReturn = from || null;
    SH.querySelector('[data-body]').innerHTML = '<h2 id="pbr-sheet-h">Write a review</h2><p class="pbr__sub" style="margin:0 0 20px">Thank you for wanting to share yours' + (ctx && ctx.title ? ' about the ' + esc(ctx.title) : '') + '. Send it to us through our <a href="/pages/contact-us">contact page</a>, with a photo if you like.</p><button type="button" class="pbr-pill" data-x>Close</button>';
    document.documentElement.classList.add('pbr-locked');
    SH.classList.add('is-open');
    var b = SH.querySelector('[data-body] [data-x]'); if (b) b.focus({ preventScroll: true });
  }
  function shClose() {
    if (!SH) return;
    SH.classList.remove('is-open');
    document.documentElement.classList.remove('pbr-locked');
    if (shReturn && shReturn.focus) try { shReturn.focus({ preventScroll: true }); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-pbr-write]'); if (!w) return;
    e.preventDefault(); shOpen({ handle: w.getAttribute('data-handle') || '', title: w.getAttribute('data-title') || '' }, w);
  });
  // Integration point for the Pinbuds review tool. Inert for now: configure() stores nothing.
  window.PBReviews = {
    configure: function () {},
    openWrite: function (o) { shOpen({ handle: (o && o.productHandle) || '', title: (o && o.title) || '' }, document.activeElement); }
  };

  /* ---------- all-reviews overlay ----------
     Links to the reviews page (homepage wall, product blocks, "All reviews" row cards) open the same
     pb-all-reviews section as a layer over the current page, loaded once through the Section Rendering
     API (section_id=pb-all-reviews) on the first open; if that fails the link goes to the page itself. /pages/reviews stays a normal page (direct visits, SEO). History: #reviews,
     so Back closes it and a shared link opens it. Page scroll is locked with html.pbr-ov-locked (its own
     class, so the lightbox closing on top never releases it) and released on every close path. */
  var OV = null, ovIsOpen = false, ovPushed = false, ovIgnorePop = 0, ovReturn = null, ovLoad = null, OV_HASH = '#reviews', OV_RE = /\/pages\/reviews\/?$/;
  var ovPath = '/pages/reviews';
  function ovEligible() {
    if (OV_RE.test(location.pathname) || document.querySelector('.pbr-hist')) return false;
    var full = document.querySelector('[data-pbr="full"]');
    return !full || !!(OV && OV.contains(full));
  }
  function lenis(fn) { var l = window.lenis || window.__lenis || window.Lenis && window.Lenis.instance; if (l && typeof l[fn] === 'function') try { l[fn](); } catch (e) {} }
  function ovSkel() { var h = ''; for (var i = 0; i < 6; i++) h += '<div class="pbr-skel"></div>'; return '<div class="pbr__wrap pbr-ov__skel" aria-busy="true"><p class="pbr-note" role="status">Loading reviews</p><div class="pbr-ov__skelgrid">' + h + '</div></div>'; }
  function ovBuild() {
    if (OV) return OV;
    OV = document.createElement('div'); OV.className = 'pbr pbr-ov'; OV.setAttribute('data-lenis-prevent', '');
    OV.innerHTML = '<div class="pbr-ov__scrim" data-ovx></div><div class="pbr-ov__panel" role="dialog" aria-modal="true" aria-label="Reviews"><div class="pbr-ov__bar"><button type="button" class="pbr-lb__btn pbr-ov__x" data-ovx aria-label="Close reviews">' + CLOSE + '</button></div><div class="pbr-ov__scroll" data-lenis-prevent><div class="pbr-ov__body"></div></div></div>';
    document.body.appendChild(OV);
    OV.addEventListener('click', function (e) { if (e.target.closest('[data-ovx]')) ovClose(); });
    return OV;
  }
  function ovFetch() {
    if (ovLoad) return ovLoad;
    ovLoad = fetch(ovPath + '?section_id=pb-all-reviews', { credentials: 'same-origin' }) // by section type: the same file the page renders (its only used setting, heading, defaults to Reviews)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var tp = document.createElement('template'); tp.innerHTML = t;
        var sec = tp.content.querySelector('.pbr[data-pbr="full"]');
        if (!sec || !sec.querySelector('script[data-pbr-cfg]')) throw new Error('no reviews section');
        // the page already has the stylesheet and this script; structured data stays on /pages/reviews only
        [].forEach.call(sec.querySelectorAll('script[src], link[rel="stylesheet"], script[type="application/ld+json"]'), function (x) { x.remove(); });
        return sec;
      });
    ovLoad.catch(function () { ovLoad = null; });
    return ovLoad;
  }
  function ovOpen(from, fromHistory) {
    if (ovIsOpen) return;
    ovBuild(); ovIsOpen = true; ovReturn = from || null;
    if (!fromHistory) { try { history.pushState({ pbrOv: 1 }, '', location.pathname + location.search + OV_HASH); ovPushed = true; } catch (e) { ovPushed = false; } }
    document.documentElement.classList.add('pbr-ov-locked');
    lenis('stop');
    OV.classList.add('is-open');
    clampSoon(OV);
    var x = OV.querySelector('.pbr-ov__x'); if (x) try { x.focus({ preventScroll: true }); } catch (e) {}
    var body = OV.querySelector('.pbr-ov__body');
    if (body.getAttribute('data-ready') === '1') return;
    if (!body.firstChild) body.innerHTML = ovSkel();
    ovFetch().then(function (sec) {
      if (body.getAttribute('data-ready') === '1') return;
      body.innerHTML = ''; body.appendChild(sec); body.setAttribute('data-ready', '1');
      var h = sec.querySelector('h1, h2'); if (h) { h.id = h.id || 'pbr-ov-h'; OV.querySelector('.pbr-ov__panel').setAttribute('aria-labelledby', h.id); }
      boot();
    }).catch(function () {
      if (!ovIsOpen) return;
      // could not load the layer: go to the reviews page itself
      ovClose(true);
      location.assign(ovPath);
    });
  }
  // keepHash=false: undo the #reviews entry (Back) or strip it; true: strip it in place (we are leaving).
  function ovClose(leaving) {
    document.documentElement.classList.remove('pbr-ov-locked');
    lenis('start');
    if (!ovIsOpen || !OV) return;
    ovIsOpen = false;
    OV.classList.remove('is-open');
    if (LB && LB.classList.contains('is-open')) lbClose();
    [].forEach.call(OV.querySelectorAll('video'), function (v) { try { v.pause(); } catch (e) {} });
    var popped = false;
    if (ovPushed && !leaving && history.state && history.state.pbrOv) { ovIgnorePop = Date.now(); popped = true; history.back(); }
    if (!popped && location.hash === OV_HASH) { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} }
    ovPushed = false;
    var r = ovReturn; ovReturn = null;
    if (r && r.focus && document.documentElement.contains(r)) try { r.focus({ preventScroll: true }); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]'); if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    if (OV && OV.contains(a)) return;
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (u.origin !== location.origin || !OV_RE.test(u.pathname) || u.hash) return;
    var thm = /^\?theme=([a-z0-9-]+)$/.exec(u.search); //  a word-cloud link opens the layer with that theme
    if (u.search && !thm) return;
    if (!ovEligible()) return;
    e.preventDefault(); ovPath = u.pathname;
    if (thm) { var hb = OV && OV.querySelector('[data-pbr-hub]'); if (hb && hb._pbrSetTheme) hb._pbrSetTheme(thm[1]); else PENDING_THEME = thm[1]; }
    ovOpen(a, false);
  });
  window.addEventListener('keydown', function (e) {
    if (!ovIsOpen) return;
    if ((LB && LB.classList.contains('is-open')) || (SH && SH.classList.contains('is-open'))) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); ovClose(); }
    else if (e.key === 'Tab') trap(e, OV.querySelector('.pbr-ov__panel'));
  }, true);
  window.addEventListener('popstate', function (e) {
    if (ovIgnorePop && Date.now() - ovIgnorePop < 3000) { ovIgnorePop = 0; return; }
    ovIgnorePop = 0;
    var want = location.hash === OV_HASH;
    if (ovIsOpen && !want) { ovPushed = false; ovClose(); }
    else if (!ovIsOpen && want && ovEligible()) { ovPushed = !!(e.state && e.state.pbrOv); ovOpen(null, true); }
  });
  window.addEventListener('pagehide', function () { document.documentElement.classList.remove('pbr-ov-locked'); if (OV) OV.classList.remove('is-open'); ovIsOpen = false; lenis('start'); });
  window.addEventListener('pageshow', function (e) { if (e.persisted && location.hash === OV_HASH && ovEligible()) { ovPushed = !!(history.state && history.state.pbrOv); ovOpen(null, true); } });
  function ovFromHash() { if (location.hash === OV_HASH && ovEligible()) { ovPushed = false; ovOpen(null, true); } }

  /* ---------- boot ---------- */
  function near(el, fn) {
    if (!('IntersectionObserver' in window)) { idle(fn); return; }
    var io = new IntersectionObserver(function (en) { if (en.some(function (e) { return e.isIntersecting; })) { io.disconnect(); idle(fn); } }, { rootMargin: '600px 0px' });
    io.observe(el);
  }
  // A review photo that fails to load (media host updating) is removed instead of showing a broken frame.
  function dropImg(img) { var c = img.closest('.pbr-card'); img.remove(); if (c && !c.querySelector('.pbr-card__img')) c.classList.remove('pbr-card--photo'); }
  document.addEventListener('error', function (e) { var t = e.target; if (t && t.classList && t.classList.contains('pbr-card__img')) dropImg(t); }, true);
  function boot() {
    seedLV();
    [].forEach.call(document.querySelectorAll('.pbr-grid, .pbr[data-pbr]'), function (sc) { if (sc._pbrSettle) return; sc._pbrSettle = 1; near(sc, function () { settleCards(sc); retitle(sc); }); });
    [].forEach.call(document.querySelectorAll('.pbr-card__img'), function (img) { if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) dropImg(img); });
    [].forEach.call(document.querySelectorAll('[data-pbr]:not([data-pbr-on])'), function (root) {
      root.setAttribute('data-pbr-on', '');
      var mode = root.getAttribute('data-pbr');
      seedTitles(root); applyTitles(root);
      if (mode === 'spot') colWall(root);
      if (mode === 'full') { if (root.hasAttribute('data-pbr-hub')) near(root, function () { hub(root); }); else fullPage(root); } else if (mode === 'spot') near(root, function () { spotlight(root); });
    });
    markClamp(document);
  }
  (function () { var w = window.innerWidth; window.addEventListener('resize', function () { if (window.innerWidth === w) return; w = window.innerWidth; clampSoon(document); }, { passive: true }); })();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { clampSoon(document); });
  window.addEventListener('load', function () { clampSoon(document); });
  window.PBR = { card: card, live: LV, boot: boot, openAll: function () { if (ovEligible()) ovOpen(document.activeElement, false); else location.assign('/pages/reviews'); }, closeAll: function () { ovClose(); } };
  //  the reviews script starts once the homepage intro has lifted (at once on pages without one)
  function go() { (window.pbAfterIntro || function (f) { f(); })(function () { boot(); ovFromHash(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  //  the storefront's cart drawer also sends shopify:section:load (on document); only the editor or a reviews section re-boots
  document.addEventListener('shopify:section:load', function (e) { var t = e.target; if ((window.Shopify && window.Shopify.designMode) || (t && t !== document && t.querySelector && t.querySelector('.pbr-grid, .pbr[data-pbr]'))) boot(); });
})();
